<template>
  <div class="logs">
    <template v-if="logsList.length">
      <el-table :data="logsList" :header-cell-style="tableHeaderStyle" border style="width: 100%">
        <el-table-column prop="createTime" label="操作时间" width="160px">
          <template slot-scope="scope">
            {{ scope.row.operateTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="操作人" width="120px"></el-table-column>
        <el-table-column prop="actionDesc" label="事项类型" width="120px"></el-table-column>
        <el-table-column prop="content" label="事项描述"></el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        class="footer"
      ></el-pagination>
    </template>
    <el-empty v-else :image="require('@/assets/imgs/default.svg')" description="暂无数据"></el-empty>
  </div>
</template>
<script>
import { queryLogPageList } from '@/api/RFQ';
import { dateFormat } from '@/utils/dateFormat';
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      logsList: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
      },
    };
  },
  watch: {
    id () {
      this.getOperationLogs();
    },
  },
  filters: {
    formatDate (v) {
      return v ? dateFormat(v).format('YYYY-MM-DD HH:mm:ss') : '';
    },
  },
  mounted () {
    this.getOperationLogs();
  },
  methods: {
    tableHeaderStyle () {
      return 'background-color: #F8F8F9; color: #606266;';
    },
    // 改变每页条数
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.getOperationLogs();
    },
    // 改变页码
    handleCurrentChange (val) {
      this.page.currentPage = val;
      this.getOperationLogs();
    },
    getOperationLogs () {
      const params = {
        businessId: this.id,
        module: 'INQUIRE_PRICE', // 询价模块 -> INQUIRE_PRICE, 询单报价模块 -> INQUIRE_QUOTE_PRICE
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        orderBy: [
          {
            orderByProperty: 'createTime',
            orderByType: 'DESC',
          },
        ],
      };
      queryLogPageList(params).then(({ body }) => {
        this.logsList = body.list || [];
        this.page.total = Number(body.total) || 0;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.logs {
  padding: 12px;
  .footer {
    text-align: right;
    padding-top: 10px;
    color: #606266;
    font-weight: normal;
  }
}
</style>
